import { makeStyles } from '@material-ui/core/styles';

const fontSize = (value) => {
  const { innerHeight, innerWidth } = window;
  const percentage = parseInt( ( (((innerWidth * value) / 100) + ((innerHeight * value) / 100)) / 5) );
  return Number.isNaN( percentage ) ? value : percentage;
};

export default makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  container: {
    border: 1,
    borderRadius: 5,
    borderWidth: 10,
    borderColor: 'black'
  },
  paper: {
    margin: 'auto',
  },
  boxInside: {
    flex: 1,
    flexDirection: 'column',
  },
  image: {
    width: 128,
    height: 128,
    borderRadius: 100,
  },
  img: {
    margin: 'auto',
    display: 'flex',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  textGrid: {
    padding: 0,
  },
  titleLeft: {
    fontSize: fontSize(3.8),
    fontFamily: 'Quicksand',
    color: 'white',
  },
  descriptionLeft: {
    marginTop: 5,
    marginBottom: 5,
    fontSize: fontSize(3.4),
    fontFamily: 'inherit',
    color: 'white',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  titleRight: {
    marginTop: 0,
    fontSize: fontSize(4.3),
    color: 'black',
  },
  descriptionRight: {
    marginTop: 0,
    fontSize: fontSize(4.8),
    color: 'black'
  },
  titleBackground: {
    fontSize: fontSize(4.5),
    color: 'white',
  },
  descriptionBackground: {
    marginTop: 0,
    fontSize: fontSize(5.5),
    color: 'white'
  },
  head:{
    width: 'fit-content',
  },
  titleHeader: {
    fontSize: fontSize(4),
    fontFamily:'Quicksand',
    color: 'white',
  },
  descriptionHeader: {
    fontSize: fontSize(3.4),
    color: 'white',
    marginTop: 5,
    marginBottom: 5,
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  img_head:{
    margin: 'auto',
    display: 'flex',
    maxWidth: '100%',
    height: 'auto',
    marginLeft: 90,
  }
})
);
